import { ws } from "../../utils/common";

export const getStatsServerWS = async () => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "health/",
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};
